import {
  BoldExtension,
  BulletListExtension,
  EmojiExtension,
  HeadingExtension,
  ImageExtension,
  ItalicExtension,
  LinkExtension,
  ListItemExtension,
  OrderedListExtension,
  StrikeExtension,
  UnderlineExtension,
} from "remirror/extensions";

import { CustomIFrameExtension } from "./custom/iframe";

const extensionConstructor =
  <T extends new (options?: Record<string, unknown>) => unknown>(Cls: T) =>
  (options: Record<string, unknown> = {}) =>
    new Cls(options);

const defaultExtensions = {
  image: extensionConstructor(ImageExtension),
  heading: extensionConstructor(HeadingExtension),
  link: extensionConstructor(LinkExtension),
  iframe: extensionConstructor(CustomIFrameExtension),
  emoji: extensionConstructor(EmojiExtension),
  list: extensionConstructor(ListItemExtension),
  bulletList: extensionConstructor(BulletListExtension),
  orderedList: extensionConstructor(OrderedListExtension),
  bold: extensionConstructor(BoldExtension),
  strike: extensionConstructor(StrikeExtension),
  italic: extensionConstructor(ItalicExtension),
  underline: extensionConstructor(UnderlineExtension),
};

export const DefaultPreset = [{ name: "heading", config: { levels: [1, 2] } }];

export default defaultExtensions;
